var exports = {
  "j": "xa15a2ab7--65d91d--breadcrumbs",
  "n": "xa15a2ab7--65d91d--link",
};

module.exports = exports;
